import type { PropsWithChildren } from 'react';
import { Collapse, CollapseContent } from '@frameio/vapor';
import styles from './SettingRowCollapsible.module.css';
import { SettingRowToggle } from './SettingRowToggle';

export const SettingRowCollapsible = ({
  checked,
  children,
  label,
  onChange,
}: PropsWithChildren<{
  /** Whether the collapsible section is expanded. */
  checked: boolean;
  /** Display label for the toggle. */
  label: string;
  /** Called when the toggle state changes. */
  onChange: (checked: boolean) => void;
}>) => {
  return (
    <div className={styles.container}>
      <Collapse isShowing={checked}>
        <SettingRowToggle checked={checked} label={label} onChange={onChange} />
        <CollapseContent>
          <div className={styles.content}>{children}</div>
        </CollapseContent>
      </Collapse>
    </div>
  );
};
